import CustomState from '@rio-cloud/rio-uikit/CustomState';
import React, { FC } from 'react';

interface EmptyTruckSelectionProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

const EmptyTruckSelection: FC<EmptyTruckSelectionProps> = ({ title, description }) => {
  return (
    <CustomState
      outerClassName="position-absolute top-30pct"
      headline={title}
      message={description}
      icons={[
        { name: 'rioglyph rioglyph-truck-baseline', color: 'text-color-highlight' },
        { name: 'rioglyph rioglyph-detail-view-info', color: 'text-color-highlight' },
        { name: 'rioglyph rioglyph rioglyph-cog', color: 'text-color-highlight' }
      ]}
    />
  );
};

export default EmptyTruckSelection;
